module.exports = __webpack_public_path__ + "static/media/Flight_Briefing_solutions_image_with-label.f2590c08.jpg";